import React, { PropTypes } from 'react';
import { connect } from 'react-redux'
import moment from 'moment';
import { browserHistory } from 'react-router';
import roles from '../utils/roles';
import projectActions from '../actions/projectActionCreators'
import DatePicker from 'react-datepicker';
import Spinner from './Spinner';

require.ensure([], () => {  
    require('./DatePicker.less');
});

class Export extends React.Component {
    
    constructor(props, context) {
        super(props, context);

        this.state = {
             weekFrom: null,
             weekTo: null,
             startDateFrom: moment().subtract(7, 'days'),
             startDateTo: moment(),
             fromDateInputError: false,
             toDateInputError: false
         };
    }

     //LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO'])) {
                browserHistory.push('/');
            }
        }
    }

     //EVENT HANDLERS

     handleExportClick = () => {
         if(moment(this.state.startDateFrom).isBefore(this.state.startDateTo)) {
            this.state.fileName = "export_" + this.state.startDateFrom.format("DDMMYYYY") + "-" + this.state.startDateTo.format("DDMMYYYY");
            this.props.dispatch(projectActions.exportProjects(this.state.startDateFrom, this.state.startDateTo, this.state.fileName));
            this.state.loading = true;  
         }
     }

     handleFromDateChange = (date) => {
         this.setState({
            startDateFrom: date
         });
         
         if(moment(date).isAfter(this.state.startDateTo)) {
             this.state.fromDateInputError = true;
         }
         else {
             this.state.fromDateInputError = false;
         }
     }

     handleToDateChange = (date) => {
         this.setState({
             startDateTo: date
         });
         
         if(moment(date).isBefore(this.state.startDateFrom)) {
             this.state.toDateInputError = true;
         }
         else {
             this.state.toDateInputError = false;
         }
     }

     handleFromCalendarClick = () => {
         this.refs.datePickerFrom.handleFocus();
     }

     handleToCalendarClick = () => {
         this.refs.datePickerTo.handleFocus();
     }

    //RENDER METHOD

    render = () => {
        return (
            <div className="text-center">
                <div className="col-lg-12">
                    <span style={{ color: "#1B74AF" }}><b onClick={this.handleFromCalendarClick}>From: </b>
                        <i onClick={this.handleFromCalendarClick} className="md-today"/></span><br/>
                        <DatePicker
                            className={this.state.fromDateInputError ? "red-border" : ""}
                            showYearDropdown
                            ref="datePickerFrom"
                            dateFormat="DD.MM.YYYY"
                            selected={this.state.startDateFrom}
                            onChange={this.handleFromDateChange}
                            />
                        <br/><label className="label-day">Week: {this.state.startDateFrom.isoWeek()} / Year {this.state.startDateFrom.year()}.</label>
                </div>
            <br/>
            <span style={{ color: "#AF1B39" }}><b onClick={this.handleToCalendarClick}>To: </b> 
                <i onClick={this.handleToCalendarClick} className="md-today"/></span><br/>
                <DatePicker
                    className={this.state.toDateInputError ? "red-border" : ""}
                    showYearDropdown
                    todayButton={'Today'}
                    ref="datePickerTo"
                    dateFormat="DD.MM.YYYY"
                    selected={this.state.startDateTo}
                    onChange={this.handleToDateChange}
                    />
                <br/><label className="label-day">Week: {this.state.startDateTo.isoWeek()} / Year {this.state.startDateTo.year()}.</label>
            <br/>   
                <button onClick={this.handleExportClick} style={{ margin: "10px" }} className="btn btn-default btn-large">Export</button>
                {
                    this.props.loading ?
                    <div className="text-center"><Spinner /></div>
                    : ""
                }
            </div>
        );
    }
}

Export.propTypes = {
    dispatch: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        loading: state.projects.loading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Export);



/** WEBPACK FOOTER **
 ** ./src/app/components/Export.js
 **/